export default __webpack_public_path__ + "static/media/pic5.04c8f91d.jpg";